import { IForm } from "../../store/forms/types";
import { IPage } from "../../store/pages/types";
import { IField } from "../../store/fields/types";

interface IDynamicPathParams {
    form_id?: IForm["_id"];
    page_id?: IPage["_id"];
    field_id?: IField["_id"];
    marker_id?: string;
    removeFields?: boolean;
    option_id?: string;
    font_name?: string;
    promocode_id?: string;
    payment_settings_id?: string;
    queries?: string;
    instance?: string;
    compId?: string;
}

export enum ApiPaths {
    // Auth
    SIGN_IN = "auth/login",
    SIGN_UP = "auth/register",
    REFRESH_TOKEN = "auth/refresh-token",
    CONFIRM_USER = "auth/activate",
    MIGRATE_USER = "/forms/migrate/user",
    CURRENT_USER = "/users/current",
    // Forms
    GET_FORMS = "forms",

    // Fonts
    GET_USER_FONTS = "forms/user-settings/fonts",
    ADD_USER_FONT = "forms/user-settings/fonts",

    SEND_BOT_MESSAGE = "chat",
}

export const ApiDynamicPaths = ({
    form_id,
    page_id,
    field_id,
    removeFields,
    option_id,
    marker_id,
    font_name,
    promocode_id,
    payment_settings_id,
    queries,
    compId,
    instance,
}: IDynamicPathParams) => ({
    // Forms
    UPDATE_FORM: `forms/${form_id}`,
    DELETE_FORM: `forms/${form_id}`,
    TRANSFER_FORM: `forms/transferForm?instance=${instance}&compId=${compId}`,
    TRANSFER_SUBMISSIONS: `/submissions/transferSubmissions?instance=${instance}&compId=${compId}&formId=${form_id}`,
    // Pages
    CREATE_PAGE: `forms/${form_id}/pages`,
    DELETE_PAGE: `forms/${form_id}/pages/${page_id}?removeFields=${removeFields}`,
    UPDATE_PAGE_ORDER: `/forms/${form_id}/pages/${page_id}/order`,
    UPDATE_PAGE: `forms/${form_id}/pages/${page_id}`,
    UPDATE_PAGES: `forms/${form_id}/pages`,

    // Fields
    ADD_FIELD: `forms/${form_id}/fields`,
    DUPLICATE_FIELD: `forms/dublicate/field`,
    DELETE_FIELD: `forms/${form_id}/fields/${field_id}`,
    UPDATE_FIELD: `forms/${form_id}/fields/${field_id}`,

    // Layout
    UPDATE_LAYOUT: `forms/${form_id}/layout-info`,

    //Selectable Options
    ADD_SELECTABLE_OPTIONS: `forms/${form_id}/fields/${field_id}/options`,
    ADD_BULK_SELECTABLE_OPTIONS: `forms/${form_id}/fields/${field_id}/options`,
    DELETE_SELECTABLE_OPTION: `forms/${form_id}/fields/${field_id}/options/${option_id}`,
    DELETE_BULK_SELECTABLE_OPTIONS: `forms/${form_id}/fields/${field_id}/options/all`,
    UPDATE_SELECTABLE_OPTIONS: `forms/${form_id}/fields/${field_id}/options/${option_id}`,
    ORDER_SELECTABLE_OPTIONS: `forms/${form_id}/fields/${field_id}/options/${option_id}/order`,

    //Map field markers
    ADD_MARKER: `forms/${form_id}/fields/${field_id}/markers`,
    ORDER_MARKERS: `forms/${form_id}/fields/${field_id}/markers/${marker_id}/order`,
    UPDATE_MARKER: `forms/${form_id}/fields/${field_id}/markers/${marker_id}`,
    DELETE_MARKER: `forms/${form_id}/fields/${field_id}/markers/${marker_id}`,

    // Fonts
    DELETE_USER_FONT: `forms/user-settings/fonts?name={${font_name}}`,

    /*  Payment  */
    UPDATE_PAYMENT_SETTINGS: `forms/payment/settings/${form_id}`,

    //promoCodes
    CREATE_PAYMENT_PROMOCODE: `forms/payment/promocode/${form_id}`,
    UPDATE_PAYMENT_PROMOCODE: `forms/payment/promocode/${promocode_id}`,
    DUPLICATE_PAYMENT_PROMOCODE: `forms/payment/promocode/dublicate/${promocode_id}`,
    DELETE_PAYMENT_PROMOCODE: `forms/payment/promocode/${promocode_id}`,
    GET_PAYMENT_PROMOCODES_LIST: `forms/payment/promocode/list/${payment_settings_id}`,

    //cash
    ACTIVATE_PAYMENT_CASH: "forms/activate/cash",

    //stripe
    GET_PAYMENT_STRIPE_AUTH_URL: `forms/payment/stripe/auth/url`,
    GET_PAYMENT_SQUARE_AUTH_URL: `forms/payment/square/auth/url`,
    UPDATE_PAYMENT_STRIPE_AUTH: `forms/stripe/auth/callback?${queries}`,
    UPDATE_PAYMENT_SQUARE_AUTH: `forms/stripe/auth/callback?${queries}`,

    GET_SQUARE_SUBSCRIPTION_PLANS: `forms/payments/${payment_settings_id}/square/subs`,
    //paypal
    UPDATE_PAYMENT_PAYPAL_AUTH: `forms/paypal/authorize`,

    //disconnect payment method
    DISCONNECT_PAYMENT_METHOD: `forms/method/disconnect`,

    //hubspot

    HUBSPOT_AUTH_URL: `/forms/${form_id}/integrations/hubspot/connect`,
    GET_HUBSPOT_DATA: `/forms/${form_id}/integrations/hubspotData`,
    GET_HUBSPOT_STATUS: `/forms/${form_id}/integrations/hubspot/status`,
    UPDATE_HUBSPOT_PROPERTY: `/forms/${form_id}/integrations/update/hubspot`,
    GET_HUBSPOT_TABLES: `/forms/${form_id}/integrations/hubspot/tables`,
    HUBSPOT_INIT: `forms/init/hubspot`,

    //disconnect integration

    DISCONNECT_INTEGRATION: `/forms/${form_id}/integrations/disconnect`,

    // zapier

    ZAPIER_AUTH_URL: `/forms/${form_id}/integrations/zapier/auth_url`,
});
